// delete user account
export const DELETE_USER_ACCOUNT = 'DELETE_USER_ACCOUNT'
export const DELETE_USER_ACCOUNT_INIT = 'DELETE_USER_ACCOUNT_INIT'
export const DELETE_USER_ACCOUNT_SUCCESS = 'DELETE_USER_ACCOUNT_SUCCESS'
export const DELETE_USER_ACCOUNT_FAIL = 'DELETE_USER_ACCOUNT_FAIL'
